import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
import { setLoading } from "../loading/loadingSlice";

export const getVersionList = createAsyncThunk("t&c_pp/versions", async ({ page, limit }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.get(`/api/v1/cc/t&c_pp/versions`, {
      params: {
        page,
        limit,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error getting versions :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error getting versions";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const getOneVersionDocx = createAsyncThunk("getOneVersionDocx", async ({ userId }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.get(`/api/v1/cc/t&c_pp/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error getting data :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error getting data";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const getLatestVersionDocs = createAsyncThunk("getLatestVersionDocs", async (_, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.get(`/api/v1/cc/t&c_pp/latest`);
    return response.data;
  } catch (error) {
    console.error("Error getting data :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error getting data";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const updateTncPP = createAsyncThunk("updateTncPP", async ({ data }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.put(`/api/v1/cc/t&c_pp/save`, {
      ...data,
    });
    return response.data;
  } catch (error) {
    console.error("Error updating data :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error updating data";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});

export const publishDoc = createAsyncThunk("t&c_pp/publish", async ({ id }, { dispatch }) => {
  try {
    console.log(id);
    dispatch(setLoading(true));
    const response = await api.put(`/api/v1/cc/t&c_pp/publish/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error getting versions :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error getting versions";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
